const CreateProfileAddressObject = (
	country,
	email,
	addressObject,
	addressId = null,
	makeDefaultAddress = false
) => {
	const {
		addressType = '',
		firstName,
		lastName,
		deliveryInstructions = '',
		deliveryInstructionsOtherInput = '',
		companyName = '',
		address1,
		address2 = '',
		address3 = null,
		dayPhoneNumber,
		phoneNumber,
		city,
		postalCode,
		makeDefault = false,
		stateCode,
		salutation = '',
	} = addressObject;

	let deliveryInstructionTxtLine1 = '',
		deliveryInstructionTxtLine2 = '',
		deliveryInstructionTxtLine3 = '',
		deliveryInstructionTxtLine4 = '';
	if (deliveryInstructions && deliveryInstructionsOtherInput) {
		let deliveryInstructionsArray =
			deliveryInstructionsOtherInput.match(/.{1,24}/g);
		[
			deliveryInstructionTxtLine1 = '',
			deliveryInstructionTxtLine2 = '',
			deliveryInstructionTxtLine3 = '',
			deliveryInstructionTxtLine4 = '',
		] = deliveryInstructionsArray;
	}

	let finalAddressType = addressType
		? addressType
		: companyName.length > 0
		? 'Commercial'
		: 'Residential';

	let shippingNewAddress = {
		contactInfo: {
			deliveryPhoneNumber: dayPhoneNumber || phoneNumber,
			email: email,
			companyName: companyName,
			dayPhoneNumber: dayPhoneNumber || phoneNumber,
		},
		address: {
			address1,
			address2,
			address3,
			city,
			country,
			postalCode,
			type: country,
			addressType: finalAddressType,
			deliveryInstructions: {
				deliveryInstruction: deliveryInstructions,
				deliveryInstructionTxtLine1,
				deliveryInstructionTxtLine2,
				deliveryInstructionTxtLine3,
				deliveryInstructionTxtLine4,
			},
		},
		personalInfo: {
			salutation,
			firstName,
			lastName,
		},
	};

	if (country === 'AU') {
		shippingNewAddress = {
			...shippingNewAddress,
			address: {
				...shippingNewAddress.address,
				state: stateCode,
				stateCode,
			},
		};
	}

	let finalObject = {
		shippingNewAddress,
		createBillingAddrflag: false,
	};

	if (makeDefault || makeDefaultAddress) {
		finalObject = {
			...finalObject,
			options: {
				addressOptions: ['DEFAULT_ADDRESS'],
			},
		};
	}

	if (addressId) {
		finalObject = {
			...finalObject,
			addressId,
		};
	}

	return finalObject;
};

export default CreateProfileAddressObject;
